import { formatCSV } from './format-csv.js';
import { downloadCSV } from '../../../core/utils/download.js';
import { CSS_DOWNLOAD_FILENAME } from '../../core/constants.js';
import { HistogramSeries } from '../types/histogram.js';

/**
 * Builds CSV from Histogram raw data and downloads the file
 *
 * @param series - Histogram series
 */
export const buildAndDownloadCsv = (series: HistogramSeries[]) => {
  const csvString = formatCSV(series);
  downloadCSV(csvString, CSS_DOWNLOAD_FILENAME);
};
